import '../styles/AuthPrompt.css'

function AuthPrompt({ authUrl, onAuth }) {
  return (
    <div className="auth-prompt">
      <div className="auth-prompt-content">
        <h2>Connect to Twitch</h2>
        <p>Authentication required to connect to chat</p>
        <button onClick={onAuth} className="auth-button">
          <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
            <path d="M11.571 4.714h1.715v5.143H11.57zm4.715 0H18v5.143h-1.714zM6 0L1.714 4.286v15.428h5.143V24l4.286-4.286h3.428L22.286 12V0zm14.571 11.143l-3.428 3.428h-3.429l-3 3v-3H6.857V1.714h13.714Z"/>
          </svg>
          Login with Twitch
        </button>
        <a href={authUrl} className="auth-link" target="_blank" rel="noopener noreferrer">
          Or open in new tab
        </a>
      </div>
    </div>
  )
}

export default AuthPrompt